module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bh-ddb mt-bColor-grey-lv5 mt-bg-lv3"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      staticClass: "bh-ddb-item mt-bColor-grey-lv5",
      class: {
        'bh-ddb-item-selected': item.active
      },
      style: ({
        width: _vm.itemWidth
      }),
      on: {
        "click": function($event) {
          _vm.setSelected(item, index, $event)
        }
      }
    }, [_c('label', {
      class: [item.active ? 'mt-color-theme' : 'mt-color-grey-lv3']
    }, [_vm._v(_vm._s(item.label))]), _c('i', {
      staticClass: "bh-ddb-i",
      class: {
        'mt-bColor-grey-lv4 bh-ddb-i-default': !item.active, 'bh-ddb-i-selected mt-bColor-theme': item.active,
      }
    })])
  })), _vm._v(" "), (_vm.isShowMenu) ? _c('div', {
    ref: "menu",
    staticClass: "bh-ddm"
  }, [_vm._t("menu")], 2) : _vm._e(), _vm._v(" "), (_vm.isShowMenu) ? _c('div', {
    staticClass: "bh-ddm-shadow",
    style: ({
      top: _vm.shadowTop
    }),
    on: {
      "click": _vm.cancelShadow
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8cfb8a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/dropdown-menus/src/dropdown-menus.vue
// module id = 483
// module chunks = 0